import { Pipe, PipeTransform } from '@angular/core';
import { MonitoredTrain } from '../models/monitored-train';

@Pipe({
  name: 'formatTrainTableData'
})
export class FormatTrainTableDataPipe implements PipeTransform {

  transform(trains: MonitoredTrain[]): unknown {
    return  trains.map(train => {
      return {
        ...train,
        name: `${train.name} (T${train.trainId})`
      }; 
    })
  }

}
